import React, { useState } from 'react'
import axios from 'axios'
import {
  List, Box, Typography, Input, Button,TableContainer, Table, TableHead, TableBody, TableRow, Paper, Pagination,
} from '@mui/material'
import { useRedirect, ResourceContextProvider } from 'react-admin'
import globalStyles from '../../utils/globalStyles'
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import legolasApi from '../../api/legolas'
import { useNavigate } from 'react-router-dom'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap',
    borderRadius: '0px !important',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding,
    borderRadius: '0px !important'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));


function NddList() {
  const [totalCount, setTotalcount] = React.useState(0);
  const [listData, setListData] = React.useState([]);
  const [searchString, setSearchString] = React.useState('');
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const localStorageUser = localStorage.getItem('user');
  const user = JSON.parse(localStorageUser);
  const userChannels = Array.isArray(user?.channel) ? user.channel.map(String) : [];
  const userid = user.id;
  const navigate = useNavigate();
  const [channelData, setChannelData] = React.useState([]);
  
  const [allTableHeaders, setAllTableHeaders] = React.useState([
    { id: 'id', label: 'Order ID', checked: true },
    { id: 'cart_quote_id', label: 'Cart ID', checked: true },
    { id: 'store_code', label: 'Store ID', checked: true },
    { id: 'city', label: 'City', checked: true },
    { id: 'delivery_method', label: 'Delivery Type', checked: true },
    { id: 'items', label: 'Items', checked: true },
    { id: 'response', label: 'Response', checked: true },
    { id: 'channel_id', label: 'Channel', checked: true },
    { id: 'updated_at', label: 'Last Updated', checked: true }
  ]);

  const isNDD = true;
  const visibleHeaders = allTableHeaders.filter(header => {
    if (isNDD && header.id === 'store_code') return false;
    return header.checked;
  });
  const getChannel = () => {
    axios.get(`${legolasApi.url}/admin/channel/list`)
      .then((res) => {
        console.log('order res: ', res.data.data);
        const allChannels = res.data.data;
        const filteredChannels = allChannels.filter(ch => userChannels.includes(ch._id));
        setChannelData(filteredChannels);
      })
      .catch((error) => console.log('Error in getting orders: ', error));
  }

  React.useEffect(() => {
    getChannel();
    setLoading(true);
    axios.get(`${legolasApi.url}/admin/storepickup/list?delivery_method=next_day_delivery&offset=${currentPage - 1}`)
      .then((res) => {

      const list = res?.data?.data?.data || [];
      const count = res?.data?.data?.count || 0;
      const filteredList = list.filter((item) => item.delivery_method === "next_day_delivery");
      setListData(filteredList);
      setTotalcount(count);
    })
    .catch((error) => {
      console.log("Error fetching store pickup list:", error);
    })
    .finally(() => {
      setLoading(false);
    });
}, [currentPage, searchString]);

  const handleSearch = () => {
    if (!searchString?.trim()) return;
    setLoading(true);
    axios.get(`${legolasApi.url}/admin/storepickup/list?delivery_method=next_day_delivery&search=${searchString}`)
      .then((res) => {
        const list = res?.data?.data?.data || [];
        const count = res?.data?.data?.count || 0;
        const filteredList = list.filter((item) => item.delivery_method === "next_day_delivery");
        setListData(filteredList);
        setTotalcount(filteredList.length);
      })
      .catch((error) => {
        console.log("Search error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handlePagination = (event, value) => {
    setLoading(true);
    axios.get(`${legolasApi.url}/admin/storepickup/list?offset=${value - 1}`)
      .then((res) => {
        const filteredList = (res?.data?.data?.data || []).filter((item) => item.delivery_method === "next_day_delivery");

        setCurrentPage(value);
        setListData(filteredList);
      })
      .catch((error) => {
        console.log("Pagination error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const formatDeliveryType = (type) => {
    let deliveryLabel = "-";
    if (type === "next_day_delivery") { deliveryLabel = "NDD";}
    if (type === "standard") { deliveryLabel = "SD";}
    if (type === "store_pickup") {deliveryLabel = "SP";}
    return deliveryLabel;
  };

  const parseItems = (items) => {
    try {
      if (!items) return "-";
      const parsedItems = typeof items === "string" ? JSON.parse(items) : items;
      if (!Array.isArray(parsedItems) || parsedItems.length === 0) {
       return "-";
      }

      return parsedItems
        .map((item) => {
          return `Product ID: ${item?.productId || "-"}, Qty: ${item?.qty || 0}`;
        })
        .join(" | ");
    } catch (error) {
      console.log("parseItems error:", error);
      return "-";
    }
  };

  const parseResponse = (response) => {
    try {
      if (!response) return "-";

      const parsedResponse =
        typeof response === "string" ? JSON.parse(response) : response;

      if (parsedResponse?.success === false && parsedResponse?.errors?.length > 0) {
        return parsedResponse.errors
          .map((item) => {
            return `Product Name: ${item?.productName || "-"}, 
Stock: ${item?.totalAvailableInCity ||
              item?.available ||
              item?.storeStock ||
              item?.productStock ||
              0
              }, 
Store: ${item?.storename || "-"}`;
          })
          .join(" | ");
      }

      if (parsedResponse?.success === true) {
        return `${parsedResponse?.message || "-"} ${parsedResponse?.storename ? `| Store: ${parsedResponse.storename}` : ""
          }`;
      }

      return "-";
    } catch (error) {
      console.log("parseResponse error:", error);
      return "-";
    }
  };


  // const parseResponse = (response) => {
  //   try {
  //     if (!response) return "-";
  //     const parsedResponse = typeof response === "string" ? JSON.parse(response) : response;

  //     if (parsedResponse?.errors?.length > 0) {
  //       return parsedResponse.errors
  //         .map((item) => {
  //           return `Product Name: ${item?.productName || "-"}, Stock: ${item?.totalAvailableInCity ||
  //             item?.available || item?.storeStock || item?.productStock || 0 }`;})
  //         .join(" | ");
  //     }

  //     return parsedResponse?.message || "-";
  //   } catch (error) {
  //     console.log("parseResponse error:", error);
  //     return "-";
  //   }
  // };


  const formatDateAndTime = (inpDate) => {
    if (!inpDate) return "-";

    const dateObj = new Date(inpDate);

    const month = dateObj.toLocaleDateString("default", {
      month: "short",
    });

    const date = dateObj.getDate();
    const year = dateObj.getFullYear();

    const hours = String(dateObj.getHours()).padStart(2, "0");
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    const seconds = String(dateObj.getSeconds()).padStart(2, "0");

    return `${month} ${date}, ${year} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <React.Fragment>
      <ResourceContextProvider resource="storepickup">
        <List actions={null}>
          {/* Header */}
          <Box sx={globalStyles.headerWrapperBox}>
            <Box sx={{ width: "50%", display: "flex", margin: "20px 30px", }}>
              <Typography variant="h4"> Next Day Delivery (NDD) List</Typography>
              <Typography variant="subtitle1" sx={globalStyles.headerCountSubtitle}>
                {totalCount} record(s) found
              </Typography>
            </Box>
          </Box>
          <Box sx={globalStyles.headerWrapperBox}>
            <Box sx={{width: "100%",display: "flex", margin: "0px 30px",justifyContent: "space-between",
                "& .MuiInput-input": { width: "300px !important",padding: "5px 10px !important",},}}
            >
              <Input type="search" placeholder="Search by keywords" sx={{ border: "1px solid #2b3f7a", borderRadius: "20px", }}
                value={searchString}
                onChange={(e) => setSearchString(e.target.value)}
                endAdornment={<SearchIcon sx={{ cursor: "pointer" }}onClick={handleSearch}/>}
              />
            </Box>
          </Box>
          <Box>
            <TableContainer component={Paper} sx={{ margin: "20px 30px",width: "94%",}}>
              <Table>
                <TableHead sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, "& .MuiTableCell-root": {
                      color: "#fff !important",padding: "10px !important",}, }}>
                  <TableRow>
                    {/* {allTableHeaders.map((header) => header.checked ? (
                        <StyledTableCell key={header.id} align="center">{header.label}</StyledTableCell>) : null)} */}
                    {visibleHeaders.map((header) => (
                      <StyledTableCell key={header.id} align="center">
                        {header.label}
                      </StyledTableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listData?.map((data, index) => (
                    <StyledTableRow key={data.id || index}>
                      <StyledTableCell align="center">{data.id || "-"}</StyledTableCell>
                      <StyledTableCell align="center">{data.cart_quote_id || "-"}</StyledTableCell>
                      {/* <StyledTableCell align="center">{data.store_code || "-"}</StyledTableCell> */}
                      {!isNDD && (<StyledTableCell align="center">{data.store_code || "-"}</StyledTableCell>)}
                      <StyledTableCell align="center">{data.city || "-"}</StyledTableCell>
                      <StyledTableCell align="center">{formatDeliveryType(data.delivery_method)}</StyledTableCell>
                      <StyledTableCell align="left">{parseItems(data.items)}</StyledTableCell>
                      <StyledTableCell align="left">{parseResponse(data.response)}</StyledTableCell>
                      <StyledTableCell align="center">{data.channel_id || "-"}</StyledTableCell>
                      <StyledTableCell align="center">{formatDateAndTime(data.updated_at)}</StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
           <Box sx={{ justifyContent: 'center' }}>
                    <Pagination count={Math.ceil(totalCount/50)} page={currentPage} onChange={handlePagination}/>
                  </Box>
        </List>
      </ResourceContextProvider>
    </React.Fragment>
  );
}





export default NddList;